import React, { FunctionComponent } from 'react';

import { SvgProps, propsHelperRem } from '@/shared/lib/propsHelper';

export const Evaluation: FunctionComponent<SvgProps> = (props) => (
    <svg {...propsHelperRem(2.4, 2.4, props)}>
        <path
            fill="#fff"
            d="M12.537 1.015c.111-.028.714-.014 1.348.036.63.05 1.717.858 1.731.868a2.39 2.39 0 0 1 1.246 2.733L16 8.05h5.09A1.92 1.92 0 0 1 23 9.966v2.015c0 .25-.049.498-.144.73l-2.954 7.197-.063.126a.96.96 0 0 1-.82.466H1.954l-.094-.005a.96.96 0 0 1-.51-.211l-.07-.064a.96.96 0 0 1-.28-.678V9.966a.954.954 0 0 1 .86-.953l.094-.005h4.324q.174 0 .335-.06l.105-.047a1 1 0 0 0 .268-.208l.073-.09 5.205-7.4a.48.48 0 0 1 .273-.188M3.4 18.1h2.35v-6.692H3.4zm5.621-8.116a3.4 3.4 0 0 1-.771.78V18.1h9.8l2.55-6.211v-1.438h-7.685l.759-2.99.86-3.4-.183-.09-.168-.127.002.001-.019-.013-.09-.063a6 6 0 0 0-.317-.204 4 4 0 0 0-.16-.09z"
        />
    </svg>
);
